import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1fa62452"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "speed" }
const _hoisted_2 = { class: "speed__body" }
const _hoisted_3 = { class: "speed__body-tip" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "最大下载速度设置", -1))
const _hoisted_5 = { class: "speed__body-current" }
const _hoisted_6 = { class: "speed__body-progress" }
const _hoisted_7 = { class: "speedTxt4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.speedTxt), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          ref: "speedProgress",
          class: "speed-progress",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args)))
        }, [
          _createElementVNode("div", {
            ref: "speedBar",
            class: "speed-bar",
            style: _normalizeStyle({
              width: _ctx.isLargeViewPort ? `${_ctx.percent}%` : `${_ctx.dragNum + 13}px`
            })
          }, null, 4),
          _createElementVNode("div", {
            ref: "speedCricle",
            class: "speed-cricle",
            style: _normalizeStyle({
              left: _ctx.isLargeViewPort ? `${_ctx.percent}%` : `${_ctx.dragNum + 7}px`
            }),
            onTouchstart: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isDrag = true)),
            onTouchcancel: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isDrag = false)),
            onTouchend: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isDrag = false)),
            onMousedown: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isDrag = true)),
            onMouseup: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isDrag = false))
          }, null, 36)
        ], 512)
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.marks, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "speed-txt",
            key: item
          }, [
            _createElementVNode("span", null, _toDisplayString(item), 1)
          ]))
        }), 128))
      ])
    ])
  ]))
}